import { enGB } from 'date-fns/locale';

var en_GB = {
  formats: {
    date: "dd/mm/yyyy",
    dateMonth: "mm/yyyy",
    dateLocale: enGB,
    quotationMarkOpening: "‘",
    quotationMarkClosing: "’"
  },
  texts: {
    "component.input_date.placeholder": "DD/MM/YYYY"
  }
};

export { en_GB };
